import React from 'react'
import { Button } from 'semantic-ui-react'
import { uniqueKey } from '../common/keys'

const ButtonTabs = ({ items, handleButtonSelect }) => {

  const _buttons = items.map((item, index) => {
    return <Button
      key={uniqueKey('ms', 'b', index)}
      className={item.selected ? 'btn-sel' : null}
      color={item.selected ? 'blue' : null}
      onClick={() => { handleButtonSelect(item, index) }}
    >{item.name || item}</Button>
  })

  return <div className='ms-button-group msb bts' >
    <Button.Group size={'mini'} >
      {_buttons}
    </Button.Group>
  </div>
}

export default ButtonTabs